module.exports = __webpack_public_path__ + "static/media/Sunny soffa 3-sits XL tyg orinocco grey miljö 2023 2.e6a7ace6.jpg";